import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Row, Col, Button, Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons"; // Ícono de hamburguesa
import Menu from "../components/Menu/MenuIndicadores.jsx";
import ContenidoIndicador from "../components/ContenidoIndicador/ContenidoIndicador.jsx";
import ViewIndicadores from "../components/Indicadores/ViewIndicadores.jsx";
import { getIndicadores } from "../services/IndicadoresService";
import "../styles/Indicadores.css";

const Indicadores = () => {
  const [defaultUrl, setDefaultUrl] = useState("");
  const [menuVisible, setMenuVisible] = useState(false); // Cambiado a false por defecto
  const [showContenido, setShowContenido] = useState(true);
  const [nameView, setNameView] = useState("");
  const [fichasJson, setFichasJson] = useState({});
  const [nameTema, setNameTema] = useState("Demografía y población");
  const [nameArea, setNameArea] = useState("Sociodemográficos");

  useEffect(() => {
    const fetchIndicadores = async () => {
      try {
        const { data } = await getIndicadores();
        if (
          data.length > 0 &&
          data[0].temas.length > 0 &&
          data[0].temas[0].indicadores.length > 0
        ) {
          const primerIndicador = data[0].temas[0].indicadores[0];
          const primeraUrl = primerIndicador.url;
          const primerNameView = primerIndicador.name_view;
          const primerFichasJson = primerIndicador.fichas_json;
          setDefaultUrl(primeraUrl);
          setNameView(primerNameView);
          setFichasJson(primerFichasJson);
        }
      } catch (error) {
        console.error("Error al obtener indicadores:", error);
      }
    };

    fetchIndicadores();
  }, []);

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Indicadores Tángara</title>
      </Helmet>

      <div>
        <h1 className="title-background">INDICADORES</h1>
      </div>

      <div className="container">
        <div style={{ marginBottom: "5%" }}>
          <Row
            gutter={[16, 16]}
            style={{
              marginTop: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              style={{
                height: "100%",
                color: "#817EA5",
                fontFamily: "Montserrat, sans-serif",
                fontSize: "16px",
              }}
            >
              <p className="parrafo-indicadores">
                Desde la Oficina Asesora de Planeación de la Gobernación del
                Cauca, ponemos a su disposición esta sección, donde encontrarás
                información de 111 indicadores agrupados en 3 áreas temáticas:
                <strong> Sociodemográfico, Económico y Ambiental</strong>, que dan cuenta las
                dinámicas y condiciones de cada uno de los 42 municipios del
                departamento del Cauca, el cual permitirá tomar decisiones
                informadas, evaluar el cumplimiento de objetivos, identificar
                áreas de mejora, asignar recursos eficientemente y mantener un
                seguimiento a largo plazo, contribuyendo así, con la
                transparencia y accesibilidad de la información.
              </p>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              className="contenedor-background-image2"
            >
              <img
                src={require("../assets/images/Indicadores 2.png")}
                alt="Descripción de la imagen"
                style={{ width: "80%", height: "auto" }}
              />
            </Col>
          </Row>
        </div>
      </div>

      <div className="container-fluid">
        {/* Ícono de Menú Hamburguesa para Móviles */}
        <Button
          type="primary"
          icon={<MenuOutlined style={{ fontSize: "24px" }} />}
          onClick={toggleMenu}
          style={{
            display: "inline-flex", // Asegura que el contenido se adapte dinámicamente
            alignItems: "center", // Centra verticalmente el texto e ícono
            justifyContent: "center", // Centra el contenido horizontalmente
            margin: "10px 20px",
            padding: "10px 16px", // Ajusta el espacio interno del botón
            fontSize: "16px",
            fontWeight: "bold",
            backgroundColor: "#007BFF",
            color: "#FFF",
            borderRadius: "8px",
            border: "none",
            cursor: "pointer",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            transition: "all 0.3s ease",
            whiteSpace: "nowrap", // Evita que el texto se divida en varias líneas
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#0056b3";
          }}

        >
          {menuVisible ? "Ocultar Menú" : "INDICADORES DISPONIBLES"}
        </Button>



        {/* Menú en un Drawer */}
        <Drawer
          title="Menú"
          placement="right"
          closable={true}
          onClose={toggleMenu}
          open={menuVisible}
        >
          <Menu
            setDefaultUrl={setDefaultUrl}
            setShowContenido={setShowContenido}
            setNameView={setNameView}
            setFichasJson={setFichasJson}
            setNameArea={setNameArea}
            setNameTema={setNameTema}
          />
        </Drawer>

        <Row gutter={16} style={{ marginTop: "10px" }}>
          <Col
            className="contenido-indicador-container"
            xs={24}
            sm={24}
            md={menuVisible ? 17 : 23}
            lg={menuVisible ? 17 : 23}
          >
            {showContenido ? (
              <ContenidoIndicador
                urlInicial={defaultUrl}
                nameView={nameView}
                fichasJson={fichasJson}
                NameArea={nameArea}
                NameTema={nameTema}
              />
            ) : (
              <ViewIndicadores url={defaultUrl} nameView={nameView} />
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Indicadores;
